<div class="container-fluid">

  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
{{ "bikeshop.menu.inventory_summary" | translate }}
</span>
    </div>
  </div>
  <div class="explanation"
       *ngIf="!busy && inventoryData !== null">{{ 'bikeshop.inventory_summary.explanation' | translate }}</div>
  <div class="error"
       *ngIf="!busy && inventoryData === null">{{ 'bikeshop.inventory_summary.error_fetching_data' | translate }}</div>
  <div class="content">

    <div class="row margin-top-8">
      <div class="col-md-4">
        <div style="width: 100%; float: left;">
          <daz-icon class=" icon-shift-12 iso-search-icon-service" [name]="'search'" [size]="'22px'"
                    [color]="'#888888'"></daz-icon>
          <input style="width: 300px;" type="text" class="iso-search-bar-service" [(ngModel)]="search"
                 placeholder="{{ 'bikeshop.inventory_summary.search' | translate }}"
                 (keyup.enter)="searchSummary()"/>
        </div>
      </div>
    </div>

    <div class="no-stock-message"
         *ngIf="!busy && inventoryData && inventoryData.length === 0">{{ "bikeshop.inventory_summary.no_stock_booked_out_hubtiger" | translate }}</div>

    <div class="products-container">
      <div *ngFor="let item of inventoryData" class="inventory-product">
        <div class="sku" (click)="openAuditSKU(item.SKU)">{{item.SKU}}</div>
        <div class="product-name">{{item.Name}}</div>
        <div class="line border margin-top-16">
          <div class="metric">
            {{ "bikeshop.inventory_summary.outstanding_adjustments" | translate }}
          </div>
          <div class="value">
            {{item.ActualQuantityAdustment}}
          </div>
        </div>
        <div class="line">
          <div class="metric">
            {{ "bikeshop.inventory_summary.open_jobcards" | translate }}
          </div>
          <div class="value">
            {{countOpenJobCards(item.JobCards)}}
            <span class="fa fa-chevron-right"
                  [ngClass]="{'fa-chevron-right' : !item.ShowOpenJobs, 'fa-chevron-down' : item.ShowOpenJobs }"
                  (click)="item.ShowOpenJobs = !item.ShowOpenJobs"></span>
          </div>
        </div>
        <div *ngIf="item.ShowOpenJobs">
          <ul>
            <li *ngFor="let jobcard of getOpenJobCards(item.JobCards)">
              <span (click)="openAuditSKUJobCardNo(item.SKU, jobcard.JobCardNo)">#{{jobcard.JobCardNo}}
                - {{jobcard.Customer}} => {{jobcard.ActualQuantityAdustment}}</span>
            </li>
          </ul>
        </div>
        <div class="line">
          <div class="metric">
            {{ "bikeshop.inventory_summary.completed_jobcards" | translate }}
          </div>
          <div class="value">
            {{countCompletedJobCards(item.JobCards)}}
            <span class="fa fa-chevron-right"
                  [ngClass]="{'fa-chevron-right' : !item.ShowCompletedJobs, 'fa-chevron-down' : item.ShowCompletedJobs }"
                  (click)="item.ShowCompletedJobs = !item.ShowCompletedJobs"></span>
          </div>
        </div>
        <div *ngIf="item.ShowCompletedJobs">
          <ul>
            <li *ngFor="let jobcard of getCompletedJobCards(item.JobCards)">
              <span (click)="openAuditSKUJobCardNo(item.SKU, jobcard.JobCardNo)">#{{jobcard.JobCardNo}}
                - {{jobcard.Customer}} => {{jobcard.ActualQuantityAdustment}}</span>
            </li>
          </ul>
        </div>
        <div class="line" [ngClass]="{ 'inventory-warn' : countCollectedJobCards(item.JobCards) !== 0 }">
          <div class="metric">
            {{ "bikeshop.inventory_summary.collected_jobcards" | translate }}
          </div>
          <div class="value">
            {{countCollectedJobCards(item.JobCards)}}
            <span class="fa fa-chevron-right"
                  [ngClass]="{'fa-chevron-right' : !item.ShowCollectedJobs, 'fa-chevron-down' : item.ShowCollectedJobs }"
                  (click)="item.ShowCollectedJobs = !item.ShowCollectedJobs"></span>
          </div>
        </div>
        <div *ngIf="item.ShowCollectedJobs">
          <ul>
            <li *ngFor="let jobcard of getCollectedJobCards(item.JobCards)"
                [ngClass]="{ 'inventory-warn' : item.ActualQuantityAdustment !== 0 }">
              <span (click)="openAuditSKUJobCardNo(item.SKU, jobcard.JobCardNo)">#{{jobcard.JobCardNo}}
                - {{jobcard.Customer}} => {{jobcard.ActualQuantityAdustment}}</span>
              <span><p-checkbox [(ngModel)]="jobcard.selected" [binary]="true"></p-checkbox></span>
            </li>
          </ul>
        </div>
        <div class="line" [ngClass]="{ 'inventory-warn' : countCancelledJobCards(item.JobCards) !== 0 }">
          <div class="metric">
            {{ "bikeshop.inventory_summary.cancelled_jobcards" | translate }}
          </div>
          <div class="value">
            {{countCancelledJobCards(item.JobCards)}}
            <span class="fa fa-chevron-right"
                  [ngClass]="{'fa-chevron-right' : !item.ShowCancelledJobs, 'fa-chevron-down' : item.ShowCancelledJobs }"
                  (click)="item.ShowCancelledJobs = !item.ShowCancelledJobs"></span>
          </div>
        </div>
        <div *ngIf="item.ShowCancelledJobs">
          <ul>
            <li *ngFor="let jobcard of getCancelledJobCards(item.JobCards)"
                [ngClass]="{ 'inventory-warn' : item.ActualQuantityAdustment !== 0 }">
              <span (click)="openAuditSKUJobCardNo(item.SKU, jobcard.JobCardNo)">#{{jobcard.JobCardNo}}
                - {{jobcard.Customer}} => {{jobcard.ActualQuantityAdustment}}</span>
              <span><p-checkbox [(ngModel)]="jobcard.selected" [binary]="true"></p-checkbox></span>
            </li>
          </ul>
        </div>
        <div class="margin-top-8" *ngIf="buttonEnabled(item) || item.busy">
          <button pButton type="button" class="p-mini full-width icon"
                  label="{{ 'bikeshop.inventory_summary.correct_stock' | translate }}"
                  (click)="correctLightSpeedBalance(item)" icon="pi pi-spin pi-spinner" iconPos="right"
                  [disabled]="item.busy || !buttonEnabled(item)"></button>
        </div>
        <div class="margin-top-8" *ngIf="buttonEnabled(item) || item.busy">
          <button pButton type="button" class="p-mini green full-width icon"
                  label="{{ 'bikeshop.inventory_summary.correct_balance_in_hubtiger' | translate }}"
                  icon="pi pi-spin pi-spinner" iconPos="right"
                  (click)="correctHubtigerBalance(item)"
                  [disabled]="item.busy || !buttonEnabled(item)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog></p-confirmDialog>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
